import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ReactGA from 'react-ga4';

/**
 * Redirect page for the ambulance QR code.
 * The QR code on the ambulance wrap points to /notalone.
 * This page tracks the scan and redirects to the homepage.
 */
const NotAloneRedirect: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Track ambulance QR code scan
    ReactGA.event({
      category: 'engagement',
      action: 'ambulance_qr_scanned',
      label: 'notalone',
    });

    // Redirect to homepage
    navigate('/', { replace: true });
  }, [navigate]);

  // Brief loading state while redirect happens
  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100">
      <div className="text-center">
        <div className="spinner-border text-primary mb-3" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p>Redirecting...</p>
      </div>
    </div>
  );
};

export default NotAloneRedirect;
